import { APP_NAME } from '@/config/app';

import type { IconProps } from './icon-types';

/**
 * App logo — layered V-stitch brand mark in fixed brand colors.
 * Source art: stitchpress-design repo, stitchpress-logo/dist/icon-only.svg
 * (viewBox tightened to the mark's bounds so it sits flush next to text).
 */
export function AppLogoIcon({ title = APP_NAME, ...props }: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="278 291 468 468"
            width="1em"
            height="1em"
            fill="none"
            aria-label={title}
            role="img"
            {...props}
        >
            <title>{title}</title>
            <path
                d="M322 380L512 720L702 380"
                stroke="#c46a1d"
                strokeWidth={78}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M411 312L512 516L613 312"
                stroke="#e8b88e"
                strokeWidth={42}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
